export default class BaseReducer {

	static get normalizers() {
		return {};
	}

	/**
	 * Normalizes data only if they are present
	 *
	 * @param {object} state
	 * @return {*}
	 */
	static normalize (state) {
		const normalizers = this.normalizers;
		return Object.keys(normalizers).reduce(
			(normalizedState, key) => {
				const normalizer = normalizers[key];
				if (normalizer && state[key] && normalizer.normalize instanceof Function) {
					normalizedState[key] = normalizer.normalize(state[key]);
				}
				return normalizedState;
			},
			{ ...state }
		);
	}
}


// WEBPACK FOOTER //
// ./reducers/BaseReducer.js